import _ from 'lodash';
import { getParentIdByPath } from '../../utils';
import workspaceService from '../../services/workspace.service';

export const getByIdCategory = (category, idToSearch) => {
  if (category.children && category.children.length !== 0) {
    let result;
    category.children.forEach(item => {
      if (result) return false;
      let res = getByIdCategory(item, idToSearch);

      if (res) result = res;
    });

    return result;
  }

  if (category.knowledge_item_medias && category.knowledge_item_medias !== 0) {
    return category.knowledge_item_medias.find(({ id }) => idToSearch === id);
  }
};

export const getLabRoot = ({ categories }) => {
  //support orgs with and without workspaces
  if (!workspaceService.hasWorkspaces()) {
    if (!categories) return {};
    return categories.find(category => category.path === 'ROOT');
  }

  const workspaceId = workspaceService.getSelectedWorkspaceId();

  if (!categories || !workspaceId) return {};

  return (
    categories.find(category => category.path === 'ROOT' && category.workspaceId === workspaceId) ??
    {}
  );
};

export const getCategoriesByPath = ({ categories, categoriesById }, path) => {
  if (_.isNull(categories)) return null;

  let parentId = getParentIdByPath(path);

  return getLabCategoriesById({ categoriesById }, parentId);
};

export const getLabCategoriesById = ({ categoriesById }, id) => {
  if (_.isNull(categoriesById)) return null;

  if (!categoriesById[id]) return null;

  return categoriesById[id].subcategories.map(i =>
    getLabCategoryById({ categoriesById }, { id: i }),
  );
};

export const getLabCategoryById = ({ categoriesById }, { id }) => {
  return categoriesById[id] || {};
};

export const getItemById = ({ itemsById }, { id }) => {
  return itemsById[id] || null;
};

export const generateBreadcrumbs = ({ categoriesById }, { pathParts }) => {
  return pathParts
    ? pathParts.filter(id => id.toUpperCase() !== 'ROOT').map(id => categoriesById[id])
    : [];
};

export const getItemsByCategoryId = ({ itemsById, categoriesById }, { id }) => {
  let { values = [] } = categoriesById[id] || {};

  return values.map(id => itemsById[id] || null).filter(i => !!i);
};

export const getLabParentsByItemId = ({ categories }, { id }) => {
  return categories.filter(i => i.type === 'values' && i.values.includes(id));
};

export const getLocations = ({ categories, categoriesById }, { type = 'category', path }) => {
  const workspaceId = workspaceService.getSelectedWorkspaceId();
  const filteredCategories = categories.filter(category => category?.workspaceId === workspaceId);
  let locations = [];

  // check if need to section or category
  if (path.split(',').length % 2 !== 0) {
    locations = filteredCategories.filter(
      i => i.type === type && i.pathParts?.length % 2 === 0 && !!i.path,
    );

    let root = getLabRoot({ filteredCategories });
    locations.unshift({ fullPath: root.id, title: root.title });
  } else {
    locations = filteredCategories.filter(i => i.type === type && i.pathParts?.length % 2 !== 0);
  }

  return locations.map(item => {
    let path = generateBreadcrumbs({ categoriesById }, { pathParts: item.pathParts }).map(
      t => t?.title,
    );

    path = [...path, item.title].reverse();

    // Remove lab base root
    if (path.length > 1) {
      path.pop();
    }

    return {
      id: item.fullPath,
      value: path.join(' | '),
    };
  });
};
